import { getIsTestnetEnv } from 'helpers/env';

// AQUA issuer account:)
export const ACCOUNT_FOR_SIMULATE = 'GBNZILSTVQZ4R7IKQDGHYGY2QXL5QOFJYQMXPKWRRM5PAV7Y4M67AQUA';

// Marker keys for aquarius-markets
export const MARKET_KEY_MARKER_UP = 'GA2UB7VXXXUSEAQUAXXXAQUARIUSVOTINGWALLETXXXPOWEREDBYAQUA';

// Marker key for delegation ClaimableBalance
export const DELEGATE_MARKER_KEY = 'GA5BS7XXXAQUARIUSXXXICEXXXVOTEDELEGATIONXXXPOWEREDBYAQUA';

export const AIRDROP_2_SPONSOR = 'GDFCYDQOVJ2OEWPLEGIRQVAM3VTOQ6JDNLJTDZP5S5OGTEHM5CIWMYBH';

// Distributors accounts
export const AMM_REWARDS_KEY = 'GC6ZWKVYRAUSCLMQYKDQZNTUNVDH2J5J6IELIWHMF7THRUQJQTQFQANA';
export const SDEX_REWARDS_KEY = 'GC5VEAWX7C3GSTW7RUKJKMQWXYZFW5TH4NGI4ZQSF6LNLUYSDGBVANBA';

// Bribes collector
const BRIBES_COLLECTOR_KEY_PRODUCTION = 'GAORXNBAWRIOJ7HRMCTWW2MIB6PYWSC7OKHGIXWTJXYRTZRSHP356TW3';
const BRIBES_COLLECTOR_KEY_TESTNET = 'GC64BYVABJNU573YDSRAP2MAAR6GY5DK3VQNRRTG2ZYP6M5BISVLWWEI';
export const BRIBES_COLLECTOR_KEY = getIsTestnetEnv()
    ? BRIBES_COLLECTOR_KEY_TESTNET
    : BRIBES_COLLECTOR_KEY_PRODUCTION;
